module.exports = __webpack_public_path__ + "static/media/frameMainImg.cf057b4f.png";